import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import GlobalContainer from '../../../../components/common/Containers/GlobalContainer';
import Footer from '../../../../components/common/Footer/Footer';
import Header from '../../../../components/common/Header/Header';
import Loader from '../../../../components/common/Loaders/Loader';
import dataJson from '../../../../data/formModel.json';
import { ModalSummary } from './ModalSummary/ModalSummary';
import { Question } from './Question/Question';
import { SectionsSummary } from './Sections-summary/Sections-summary';
import useSummary from './useSummary';
const Summary = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const [sectionTitle, setSectionTitle] = useState(null);
    const [subSectionTitle, setSubSectionTitle] = useState(null);
    const [questions, setQuestions] = useState(null);
    const [data, setData] = useState(null);
    const { summaryForm, isLoading } = useSummary();
    const questionsData = dataJson.sections;
    const isMobile = useMediaQuery(theme.breakpoints.down('xl'));
    const [showModal, setShowModal] = useState(false);
    const handleShowModal = () => setShowModal((prev) => !prev);
    //TODO CREAR TREE DE NAVEGACION DE SUMMARY FORM
    useEffect(() => {
        if (summaryForm.length > 0) {
            const getAllSections = () => {
                const uniqueSectionIds = [...new Set(summaryForm.map((response) => response.currentSectionId.split('.')[0]))].sort((a, b) => a.localeCompare(b));
                const filteredSections = questionsData
                    .filter((question) => uniqueSectionIds.includes(question.id))
                    .map((section) => ({
                    contentId: section.id,
                    title: section.sectionTitle,
                }));
                return filteredSections;
            };
            const sections = getAllSections();
            const summaryDataArray = sections.map((section, index) => {
                const subSections = questionsData.filter((question) => question.id.includes(section.contentId) && summaryForm.some((response) => response.currentSectionId === question.id));
                const subContents = subSections.map((subSection, subIndex) => ({
                    contentId: section.contentId === subSection.id ? `${subSection.id}x${subIndex}` : subSection.id,
                    contentText: subSection.sectionTitle,
                    position: subIndex,
                    responses: summaryForm.filter((response) => response.currentSectionId === subSection.id),
                }));
                return {
                    contentId: section.contentId,
                    contentText: section.title,
                    position: index,
                    subContents,
                };
            });
            setData(summaryDataArray);
        }
    }, [summaryForm, questionsData]);
    const formatQuestions = (unFormatQuestions) => {
        const formatedQuestions = [];
        const questionMap = {};
        unFormatQuestions.forEach((question) => {
            const parentId = question.questionId.split('-').slice(0, -1).join('-'); // Determina el ID del padre
            // Si no hay padre, es una pregunta de nivel superior
            if (!parentId || !questionMap[parentId]) {
                formatedQuestions.push(Object.assign(Object.assign({}, question), { subQuestions: [] }));
                questionMap[question.questionId] = formatedQuestions[formatedQuestions.length - 1];
            }
            else {
                // Si hay padre, añade esta pregunta como subpregunta
                const parentQuestion = questionMap[parentId];
                if (parentQuestion) {
                    if (!parentQuestion.subQuestions)
                        parentQuestion.subQuestions = [];
                    parentQuestion.subQuestions.push(Object.assign(Object.assign({}, question), { subQuestions: [] }));
                    questionMap[question.questionId] = parentQuestion.subQuestions[parentQuestion.subQuestions.length - 1];
                }
            }
        });
        return formatedQuestions;
    };
    useEffect(() => {
        if (data && data.length > 0) {
            setSectionTitle(data[0].contentText);
            if (data[0].subContents.length > 0) {
                setQuestions(formatQuestions(data[0].subContents[0].responses));
                setSubSectionTitle(data[0].subContents[0].contentText);
            }
        }
    }, [data]);
    const handleSectionClick = (contentId) => {
        for (const section of data) {
            const foundSubsection = section.subContents.find((subSection) => subSection.contentId === contentId);
            if (foundSubsection) {
                setQuestions(formatQuestions(foundSubsection.responses));
                setSectionTitle(section.contentText); // Retornamos la subsección si coincide el ID
                setSubSectionTitle(foundSubsection.contentText);
            }
        }
        handleShowModal();
    };
    /* TODO HABRA QUE REALIZARLA DE NUEVO HAN CAMBIADO COSAS */
    /*   const downloadPdf = async () => {
      try {
        const data = await fetchUserFormResponseSummaryAsync(formId);
        const doc = new jsPDF();
  
        data.forEach((question: IQuestion) => {
          switch (question.questionType) {
            case 'binary':
              if (question.newValue == '0') {
                question.newValue = t('common.no');
              } else if (question.newValue == '1') {
                if (question.iterativeValues.length) {
                  const displayValues = question.iterativeValues.map((item) => item.displayValue);
                  question.newValue = t('common.yes') + '\n' + displayValues.join('\n');
                } else {
                  question.newValue = t('common.yes');
                }
              } else {
                question.newValue = '--';
              }
              break;
          }
        });
  
        autoTable(doc, {
          head: [['Pregunta', 'Respuesta']],
          body: data.map((item: IQuestion) => [item.questionTitle, item.newValue]),
          headStyles: {
            fillColor: [255, 0, 0], // Color rojo para el fondo del header (RGB)
            textColor: [255, 255, 255], // Color blanco para el texto
          },
        });
  
        doc.save('reporte.pdf');
      } catch (error) {
        console.error('Error al generar el PDF', error);
      }
    }; */
    return (_jsxs(_Fragment, { children: [_jsx(Helmet, { children: _jsx("title", { children: "SIGNO | Resumen de formulari" }) }), _jsxs(GlobalContainer, { children: [_jsx(Header, { titlePage: t('summaryForm.titlePage') }), isLoading ? (_jsx(Loader, {})) : (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "container-xl main-body-page summary-container" }, { children: summaryForm.length > 0 ? (_jsxs("div", Object.assign({ className: "row summary-wrapper" }, { children: [_jsx("div", Object.assign({ className: "col-12 col-lg-3" }, { children: _jsx(SectionsSummary, { data: data, onSectionClick: handleSectionClick }) })), _jsxs("div", Object.assign({ className: "col-lg-9 response-container" }, { children: [_jsx("div", Object.assign({ className: "row response-header" }, { children: _jsx("div", Object.assign({ className: "col-12 col-lg-9" }, { children: _jsx("p", Object.assign({ className: "paragraph m-0" }, { children: t('summaryForm.descriptionPage') })) })) })), !isMobile ? (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "row response-sections" }, { children: _jsxs("div", Object.assign({ className: "col" }, { children: [_jsx("h3", { children: t(sectionTitle) }), questions && sectionTitle !== subSectionTitle && _jsx("h4", Object.assign({ className: "mt-1" }, { children: t(subSectionTitle) }))] })) })), _jsx("div", Object.assign({ className: "row responses-wrapper" }, { children: _jsx("div", Object.assign({ className: "col" }, { children: questions &&
                                                                    questions.map((response) => _jsx(Question, { question: response }, `${response.questionId}`)) })) }))] })) : (_jsxs(ModalSummary, Object.assign({ onClose: handleShowModal, show: showModal, id: "responsesSummaryModal", cssClass: "responses-summary-modal", header: true, fullScreenQuery: isMobile ? 'modal-fullscreen-lg-down' : '' }, { children: [_jsxs("div", Object.assign({ className: "body-1" }, { children: [_jsx("h3", Object.assign({ className: "title" }, { children: t(sectionTitle) })), questions && sectionTitle !== subSectionTitle && _jsx("h4", Object.assign({ className: "subtitle" }, { children: t(subSectionTitle) }))] })), _jsx("div", Object.assign({ className: "body-2" }, { children: _jsx("div", Object.assign({ className: "container-fluid" }, { children: _jsx("div", Object.assign({ className: "row responses-wrapper" }, { children: _jsx("div", Object.assign({ className: "col" }, { children: questions &&
                                                                            questions.map((response) => _jsx(Question, { question: response }, `${response.questionId}`)) })) })) })) }))] })))] }))] }))) : (_jsx("div", Object.assign({ className: "row" }, { children: _jsx("div", Object.assign({ className: "col-12" }, { children: _jsxs("div", Object.assign({ className: "alert-message alert alert-danger error-message", role: "alert" }, { children: [_jsx(ErrorOutlineIcon, { color: "secondary" }), _jsx("span", { children: t('summaryForm.textNoSummaryData') })] })) })) }))) })), _jsx(Footer, {})] }))] })] }));
};
export default Summary;
